import {useEffect} from 'react'

export default function PTEELAFT() {
  useEffect(() => {
    const pdf = require("../../assets/static/POLITICA PTEE-LA_FT_FPADM.pdf");
    window.open(pdf, "_blank");
  }, []);

}
